module.exports = __webpack_public_path__ + "r-v3/img/btn_close.6f8b1cad.svg";